module.exports = __webpack_public_path__ + "static/img/kefu.d8f5c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/kefu.png
// module id = 1ySU
// module chunks = 1